import { delay } from "lodash";
import { t } from "@/i18n-js/instance";
import { CustomizeSpaceForm } from "@/react/components/Spaces/CustomizeSpaceFullPage/CustomizeSpaceForm";
import { OptionsForm } from "@/react/components/Spaces/CustomizeSpaceFullPage/OptionsForm";
import { Paywalls } from "@/react/components/Spaces/CustomizeSpaceFullPage/Paywalls";
import { SpaceMembersForm } from "@/react/components/Spaces/CustomizeSpaceFullPage/SpaceMembersForm";
import { Workflows } from "@/react/components/Spaces/CustomizeSpaceFullPage/Workflows";
import type { Space } from "@/react/types/Space";
import { useCustomizeUIData } from "@circle-react-shared/CustomizeUI";
import { LessonList } from "../../CourseSpace/Lessons/List";
import { Lockscreen } from "../../CourseSpace/Lockscreen";

interface CustomizeSpaceSectionSelectorProps {
  onClose: () => void;
  scrollToId?: string;
  space: Space;
}

export const CustomizeSpaceSectionSelector = ({
  onClose,
  space,
  scrollToId,
}: CustomizeSpaceSectionSelectorProps) => {
  const { currentSection } = useCustomizeUIData();
  if (scrollToId) {
    delay(() => document.getElementById(scrollToId)?.scrollIntoView(), 0);
  }

  if (currentSection === t("customize_space.paywalls.title")) {
    return <Paywalls />;
  }

  if (currentSection === t("customize_space.customize")) {
    return <CustomizeSpaceForm space={space} />;
  }

  if (currentSection === t("customize_space.members")) {
    return <SpaceMembersForm space={space} />;
  }

  if (currentSection === t("customize_space.options")) {
    return <OptionsForm space={space} />;
  }

  if (currentSection === t("customize_space.lessons")) {
    return <LessonList space={space} />;
  }

  if (currentSection === t("customize_space.lock_screen")) {
    return <Lockscreen space={space} />;
  }

  if (currentSection === t("customize_space.workflows")) {
    return <Workflows onClose={onClose} />;
  }

  return null;
};
